import Image from "next/image"
import { Desktop, Mobile } from "@/components/device"
import { useSelector } from "react-redux"

const styles = {
  mobile: {
    height: 35,
    width: "auto",
  },
  desktop: {
    height: "100%",
    width: "auto",
  },
}

const AppLogo = ({ ...props }) => {
  let logoUrl = useSelector((s) => s.configuration?.logoUrl)
  const signupCohort = useSelector((s) => s.signupCohort)
  if (signupCohort?.logoUrl) {
    logoUrl = signupCohort.logoUrl
  }
  return (
    <>
      {logoUrl && (
        <>
          <Mobile>
            <Image src={logoUrl} width={0} height={0} style={styles.mobile} alt="logo" unoptimized {...props} />
          </Mobile>
          <Desktop>
            <Image src={logoUrl} width={0} height={0} style={styles.desktop} alt="logo" unoptimized {...props} />
          </Desktop>
        </>
      )}
    </>
  )
}

export default AppLogo
